import { render, staticRenderFns } from "./oxfordNew.vue?vue&type=template&id=4b23ef8f&scoped=true"
import script from "./oxfordNew.vue?vue&type=script&lang=js"
export * from "./oxfordNew.vue?vue&type=script&lang=js"
import style0 from "./oxfordNew.vue?vue&type=style&index=0&id=4b23ef8f&prod&lang=css"
import style1 from "./oxfordNew.vue?vue&type=style&index=1&id=4b23ef8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b23ef8f",
  null
  
)

export default component.exports